<template>
  <div class="drawer-container">
    <div>
      <h3 class="drawer-title">页面设置</h3>
      <div class="drawer-item">
        <span>选择主题色</span>
        <ThemePicker style="float: right;height: 26px;margin: -3px 8px 0 0;z-index:9999"></ThemePicker>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 右侧设置抽屉内容
 * 功能：提供主题色选择
 */
import ThemePicker from "@/components/common/ThemePicker";
export default {
  components: { ThemePicker },
  data() {
    return {};
  },
  computed: {
  
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
}
</style>
